import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className"],
  _excluded2 = ["side", "className", "children", "inline", "hideClose"],
  _excluded3 = ["className"],
  _excluded4 = ["className"];
var __jsx = React.createElement;
import * as React from "react";
import * as SheetPrimitive from "@radix-ui/react-dialog";
import { Icon } from "@syarahtech/ui";
import { cn } from "@/common/lib/utils";
var Sheet = SheetPrimitive.Root;
var SheetTrigger = SheetPrimitive.Trigger;
var SheetClose = SheetPrimitive.Close;
var SheetPortal = SheetPrimitive.Portal;
var SheetOverlay = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SheetPrimitive.Overlay, _extends({
    ref: ref
    /* `bg-black/40` compiles to nothing here: tailwind.config redefines
       `black` as `{ primary }` with no DEFAULT key. */,
    className: cn("fixed inset-0 z-50 bg-[rgba(0,0,0,0.4)]", className)
  }, props));
});
SheetOverlay.displayName = SheetPrimitive.Overlay.displayName;
var sheetPanelClass = "fixed inset-y-0 z-50 flex h-full w-3/4 flex-col bg-white shadow-lg sm:max-w-sm";
var SheetContent = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var _ref2$side = _ref2.side,
    side = _ref2$side === void 0 ? "right" : _ref2$side,
    className = _ref2.className,
    children = _ref2.children,
    _ref2$inline = _ref2.inline,
    inline = _ref2$inline === void 0 ? false : _ref2$inline,
    _ref2$hideClose = _ref2.hideClose,
    hideClose = _ref2$hideClose === void 0 ? false : _ref2$hideClose,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var closeButton = hideClose ? null : /*#__PURE__*/React.createElement(SheetPrimitive.Close, {
    className: "absolute top-4 ltr:right-4 rtl:left-4 rounded-sm opacity-70 hover:opacity-100"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-rounded",
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Close"));
  if (inline) {
    return /*#__PURE__*/React.createElement(SheetPrimitive.Content, _extends({
      ref: ref,
      forceMount: true
      /* A force-mounted DismissableLayer listens even while closed, so any
         tap outside — including the one on the trigger that is about to
         open it — is reported as an outside interaction and dismisses it in
         the same tick. Hosts must guard this; see MobileSideMenu. */,
      className: cn(sheetPanelClass, side === "left" ? "left-0" : "right-0", "transition-[transform,visibility] duration-300 ease-out motion-reduce:transition-none",
      // Arbitrary transforms rather than `translate-x-*`: a plain
      // declaration instead of Tailwind's composed --tw-translate-* vars.
      "data-[state=closed]:invisible data-[state=closed]:pointer-events-none", side === "left" ? "data-[state=closed]:[transform:translateX(-100%)]" : "data-[state=closed]:[transform:translateX(100%)]", "data-[state=open]:visible data-[state=open]:[transform:none]", className)
    }, props), children, closeButton);
  }
  return /*#__PURE__*/React.createElement(SheetPortal, null, /*#__PURE__*/React.createElement(SheetOverlay, null), /*#__PURE__*/React.createElement(SheetPrimitive.Content, _extends({
    ref: ref,
    className: cn(sheetPanelClass, "transition ease-in-out", side === "left" ? "left-0" : "right-0", className)
  }, props), children, closeButton));
});
SheetContent.displayName = SheetPrimitive.Content.displayName;
var SheetTitle = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(SheetPrimitive.Title, _extends({
    ref: ref,
    className: cn("text-base font-semibold text-navy-primary", className)
  }, props));
});
SheetTitle.displayName = SheetPrimitive.Title.displayName;
var SheetDescription = /*#__PURE__*/React.forwardRef(function (_ref4, ref) {
  var className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(SheetPrimitive.Description, _extends({
    ref: ref,
    className: cn("text-sm text-[#6b7ea5]", className)
  }, props));
});
SheetDescription.displayName = SheetPrimitive.Description.displayName;
export { Sheet, SheetTrigger, SheetClose, SheetContent, SheetTitle, SheetDescription };